export default __webpack_public_path__ + "slices/main/assets/public/fonts/inter/inter-semi-bold.bfb220b7f35f45b33defe87e89dad9df.woff";